<template>
  <div>
    <v-row class="mb-4">
      <Breadcrump class="mb-2" :crumbs="crumbs" />
      <v-spacer></v-spacer>

      <v-btn
        @click="$router.go(-1)"
        class="mx-10 mt-5"
        fab
        small
        dark
        color="indigo"
      >
        <v-icon dark> mdi-arrow-left </v-icon>
      </v-btn>
    </v-row>
    <v-dialog
      v-model="dialog"
      transition="dialog-top-transition"
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5"> جزییات </v-card-title>

        <v-card-text>
          <v-radio-group v-model="selectedSubComplexId" mandatory>
            <v-radio
              :value="complexId"
              label="مجموعه اصلی"
              :key="complexId"
            ></v-radio>

            <template v-for="item in subComplexes">
              <v-radio
                :value="item.id"
                :label="item.text"
                :key="item.id"
              ></v-radio>
            </template>
          </v-radio-group>
        </v-card-text>

        <v-card-actions>
          <v-btn
            v-can="'Devices_ComplexChange'"
            color="green darken-1"
            text
            @click="addDeviceToComplex()"
          >
            تایید
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="deviceList"
      hide-default-footer
      :loading="loading"
      :server-items-length="totalDevices"
      item-key="id"
      @update="options"
      class="elevation-1"
    >
      <template :disabled="!item.active" v-slot:item.summary="{ item }">
        <v-btn
          small
          style="margin: -12px"
          v-can="`Devices_Show`"
          color="primary"
          class="white--text"
          @click="goToSummary(item.id, item.name)"
        >
          مشاهده دستگاه
        </v-btn>
      </template>
      <template v-if="!isSubComplex" v-slot:item.coplexes="{ item }">
        <v-btn
          v-can="`Devices_ComplexChange`"
          small
          style="margin: -12px"
          color="cyan"
          class="white--text"
          @click="getSubComplex(item.id)"
        >
          تغییر مجموعه
        </v-btn>
      </template>
      <template :disabled="!item.active" v-slot:item.actions="{ item }">
        <v-btn
          v-can="`Devices_Edit`"
          :disabled="!item.active"
          small
          style="margin: -12px"
          color="cyan"
          class="white--text"
          @click="editItem(item)"
        >
          تنظیمات
          <v-icon right dark> mdi-pencil </v-icon>
        </v-btn>
      </template>

      <template :disabled="!item.active" v-slot:item.details="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              :disabled="!item.active"
              style="margin: -12px"
              small
              color="primary"
              class="white--text"
              v-bind="attrs"
              v-on="on"
            >
              جزییات
              <v-icon right dark> mdi-arrow-down-drop-circle </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="menu in items"
              v-can="`${menu.permission}`"
              :key="menu.action"
              link
            >
              <v-list-item-title
                v-text="menu.name"
                @click="getAction(menu.action, item.id, item.name)"
              ></v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:item.adjust="{ item }">
        <AdjustSetting
          v-if="item.active"
          :selectedComplexId="complexId"
          :currentDevice="item.id"
          ref="adjustSettingRef"
        />
      </template>

      <template v-slot:item.sendSmsStatus="{ item }">
        <label>{{ item.sendSmsStatus ? "فعال" : "غیر فعال" }}</label>
      </template>
      <!-- <template v-slot:item.isBranded="{ item }">
        <v-chip
            :color="item.isBranded ? 'green' : 'red'"
            dark
            small
          >{{ item.isBranded ? "دارد" : "ندارد" }}</v-chip>
      </template> -->
      <template v-slot:item.delete="{ item }">
        <v-icon
          v-can="`Devices_Delete`"
          :disabled="!item.active"
          color="red"
          right
          dark
          @click="deleteDevice(item.id)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:item.onlineStatus="{ item }">
        <v-icon v-if="item.isOnline" color="teal">mdi-wifi</v-icon>
        <v-icon v-else color="error">mdi-wifi-off</v-icon>
      </template>
      <template v-slot:item.lightBoxStatus="{ item }">
        <v-icon v-if="!item.hasLightBox" color="blue">mdi-lightbulb-off</v-icon>
        <v-icon
          v-else-if="
            !LightBoxIsNotOk(item.lightBoxStatus, item.lightBoxStatusThreshold)
          "
          color="teal"
          >mdi-lightbulb-on</v-icon
        >
        <v-icon v-else color="error">mdi-lightbulb-on</v-icon>
      </template>
      <template v-slot:item.screenStatus="{ item }">
        <v-icon v-if="!item.hasScreen" color="blue">mdi-monitor-off</v-icon>
        <v-icon
          v-else-if="!LightBoxIsNotOk(item.screenStatus, item.screenThreshold)"
          color="teal"
          >mdi-monitor</v-icon
        >
        <v-icon v-else color="error">mdi-monitor</v-icon>
      </template>

      <template v-slot:header.name="{ header }">
        {{ header.text }}
        <v-menu offset-y left :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small :color="name ? 'primary' : ''">mdi-filter</v-icon>
            </v-btn>
          </template>
          <div style="background-color: white; width: 280px">
            <v-text-field
              v-model="name"
              class="pa-4"
              type="text"
              label="جستجو"
            ></v-text-field>
            <v-btn
              @click="name = ''"
              small
              text
              color="primary"
              class="ml-2 mb-2"
              >پاک کردن</v-btn
            >
          </div>
        </v-menu>
      </template>
      <template v-slot:item.active="{ item }">
        <v-switch
          v-can="'Devices_ChangeState'"
          v-model="item.active"
          flat
          @change="changeDeviceState(item)"
          :label="`${item.active ? 'فعال' : 'غیر فعال'}`"
        ></v-switch>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-col cols="3">
            <template right>
              <v-btn
                v-can="'Devices_Create'"
                color="primary"
                @click="addNewDevice"
              >
                افزودن دستگاه
              </v-btn>
            </template>
          </v-col>
          <v-spacer></v-spacer>
          <v-divider class="mx-4" inset vertical></v-divider>

          <v-toolbar-title>لیست مجموعه ها</v-toolbar-title>
        </v-toolbar>
      </template>
      <template v-slot:header.name="{ header }">
        {{ header.text }}
        <v-menu offset-y left :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small :color="name ? 'primary' : ''">mdi-filter</v-icon>
            </v-btn>
          </template>
          <div style="background-color: white; width: 280px">
            <v-text-field
              v-model="name"
              class="pa-4"
              type="text"
              label="جستجو"
            ></v-text-field>
            <v-btn
              @click="name = ''"
              small
              text
              color="primary"
              class="ml-2 mb-2"
              >پاک کردن</v-btn
            >
          </div>
        </v-menu>
      </template>
    </v-data-table>
    <v-pagination
      v-model="options.page"
      @input="next"
      :length="this.pages"
      :total-visible="7"
    ></v-pagination>
  </div>
</template>
<script>
import request from "@/utils/request";
import AdjustSetting from "@/components/device/AdjustSetting.vue";
import Vue from "vue";
import Breadcrump from "@/components/common/Breadcrump.vue";

export default {
  name: "Devices",
  components: {
    AdjustSetting,
    Breadcrump
  },
  data() {
    return {
      crumbs: [
        {
          text: "خانه",
          disabled: false,
          href: "/"
        },
        {
          text: "مجموعه ها",
          disabled: false,
          href: "/complexes"
        },
        {
          text: `مجموعه ${this.$store.state.selectedComplexName}`,
          disabled: false,
          href: `/complex-units/${this.$route.params.id}`
        },
        {
          text: "دستگاهها",
          disabled: true
        }
      ],
      items: [
        {
          action: "deviceState",
          name: "وضعیت فعلی دستگاه",
          permission: "LockerCurrentState_Show"
        },
        {
          action: "deviceCodeActivity",
          name: "کدهای فعالیت",
          permission: "CodeActivity_Show"
        },
        {
          action: "deviceAdvertise",
          name: "محتوی تبلیغاتی",
          permission: "DeviceAdvertise_Show"
        },
        {
          action: "deviceMarketing",
          name: "تنظیمات مارکتینگ دستگاه",
          permission: `Devices_MarketingEdit`
        },
        {
          action: "deviceOTADeviceForm",
          name: "آپدیت دستگاه",
          permission: `OtaList_Assignment`
        },
        {
          action: "deviceOTALogs",
          name: "گزارش نسخه های دستگاه",
          permission: `OtaList_ShowLogs`
        },
        {
          action: "deviceDb",
          name: "دیتابیس دستگاه",
          permission: `DeviceDb_Show`
        },
        {
          action: "deviceReportMultiplier",
          name: "ضریب‌دهی گزارش",
          permission: `Devices_ReportMultiply`
        },
        {
          action: "deviceSmsPanel",
          name: "پنل پیامکی",
          permission: "SmsContent_View"
        },
        {
          action: "deviceSms",
          name: "گزارش پیام‌ها",
          permission: "DeviceSms_List"
        },
        { action: "devicePin", name: "پین ها", permission: `Pins_Show` },
        {
          action: "deviceReport",
          name: "گزارش استفاده از دستگاه",
          permission: "Devices_Report"
        },
        {
          action: "deviceTimeline",
          name: "تاریخچه",
          permission: "DeviceHistory_Show"
        }
      ],
      isSubComplex: false,
      device: {},
      dialog: false,
      complexId: null,
      totalDevices: 0,
      selectedSubComplexId: 0,
      subComplexes: [],
      pages: 0,
      selectedComplex: 0,
      name: null,
      deviceList: [],
      loading: true,
      options: {
        mustSort: true,
        sortDesc: [true],
        sortBy: "active",
        thenSortBy: ["name-asc"]
      },

      headers: [
        { text: "شناسه", value: "id", sortable: true, align: " d-none" },
        { text: "نام", value: "name", sortable: true },
        { text: "ساعت آغاز کار", value: "startTime", sortable: true },
        { text: "ساعت پایان کار", value: "endTime", sortable: true },
        { text: "تعداد لاکرها", value: "lockerCount", sortable: true },
        { text: "ارسال پیامک", value: "sendSmsStatus", sortable: true },
        { text: "اعتبار پیامک", value: "smsCredit", sortable: true },
        { text: "وضعیت", value: "active", sortable: true },
        { text: "روشن / خاموش", value: "shutDownFlagStr", sortable: true },
        { text: "وضعیت ارتباط", value: "onlineStatus", sortable: true },
        { text: "لایت باکس", value: "lightBoxStatus", sortable: true },
        { text: "اسکرین", value: "screenStatus", sortable: true },
        // { text: "برند", value: "isBranded", sortable: true },
        { text: "", value: "summary", sortable: false, width: "1%" },
        { text: "", value: "coplexes", sortable: false, width: "1%" },
        { text: "", value: "details", sortable: false, width: "1%" },
        { text: "", value: "actions", sortable: false, width: "1%" },
        { text: "", value: "adjust", sortable: false, width: "1%" },
        { text: "", value: "delete", sortable: false, width: "1%" }
      ]
    };
  },

  watch: {
    options(curr, prev) {
      const watchProps = ["page", "itemsPerPage", "sortBy", "sortDesc"];

      for (let i = 0; i < watchProps.length; i++) {
        const key = watchProps[i];

        if (prev[key] !== curr[key]) {
          return this.getDevices();
        }
      }
    },
    name: function() {
      if (this.name.length > 2 || this.name.length === 0) {
        this.options.page = 1;
        this.options.name = this.name;
        this.getDevices();
      }
    }
  },
  mounted() {
    this.complexId = this.$route.params.id;
    this.$store.commit("setSelectedComplexId", this.complexId);
    this.getDevices();
    this.getIsSubComplex();
    this.openEditModal();
  },

  methods: {
    openEditModal() {
      const editDevice = this.$store.state.editDevice;
      if (editDevice && editDevice.shouldOpen) {
        this.editItem(editDevice);
      }
      const editItem = {
        shouldOpen: false,
        id: null
      };
      this.$store.commit("setEditDevice", editItem);
    },
    LightBoxIsNotOk(lightBoxStatus, lightBoxStatusThreshold) {
      return (
        lightBoxStatus > 0 &&
        lightBoxStatus < 100 &&
        lightBoxStatus < lightBoxStatusThreshold
      );
    },
    ScreenIsNotOk(screenStatus, screenThreshold) {
      return (
        screenStatus > 0 && screenStatus < 100 && screenStatus < screenThreshold
      );
    },
    async changeDeviceState(item) {
      this.switchLoading = "warning";
      await request
        .put(`/device/change-state/${item.id}`)
        .catch(error => {
          this.userState = !this.state;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editItem(item) {
      this.$router.push({
        name: "EditDevice",
        params: {
          id: this.complexId,
          deviceId: item.id
        }
      });
    },

    deleteDevice(deviceId) {
      Vue.swal({
        title: "برای حذف این دستگاه مطمئن هستید",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بله ,حذف شود",
        cancelButtonText: "انصراف"
      }).then(result => {
        if (result.isConfirmed) {
          request.delete(`/device/${deviceId}`).then(() => {
            Vue.swal("", "دستگاه با موفقیت حذف گردید", "success");
            this.getDevices();
          });
        }
      });
    },
    next(page) {
      this.options.page = page;
      this.getDevices();
    },
    handler(event) {
      this.options = event;
    },
    getAction(action, deviceId, name) {
      this.$store.commit("setSelectedDeviceName", name);
      switch (action) {
        case "deviceState":
          this.$router.push(`/device-state/${this.complexId}/${deviceId}`);
          break;

        case "deviceCodeActivity":
          this.$router.push(`/device-code-activity/${deviceId}`);
          break;

        case "deviceAdvertise":
          this.$router.push(`/device-advertise/${deviceId}`);
          break;
        case "deviceSmsPanel":
          this.$router.push(`/device-sms-panel/${deviceId}`);
          break;
        case "deviceReportMultiplier":
          this.$router.push(`/device-report-multiplier/${deviceId}`);
          break;
        case "devicePin":
          this.$router.push(`/device-pins/${deviceId}`);
          break;
        case "deviceReport":
          this.$router.push(`/device-report/${deviceId}`);
          break;
        case "deviceTimeline":
          this.$router.push(`/device-timeline/${deviceId}`);
          break;
        case "deviceMarketing":
          this.$router.push(`/device-marketing/${deviceId}`);
          break;
        case "deviceOTADeviceForm":
          this.$router.push(`/device-update/${deviceId}`);
          break;
        case "deviceOTALogs":
          this.$router.push(`/device-ota-logs/${deviceId}`);
          break;
        case "deviceDb":
          this.$router.push(`/device/${deviceId}/database`);
          break;
        case "deviceSms":
          this.$router.push(`/device-sms/${deviceId}`);
          break;
        default:
          break;
      }
    },
    getSubComplex(deviceId) {
      request
        .get(`/publicData/sub-complexes/${this.complexId}`)
        .then(response => {
          var data = response.data.result;
          this.dialog = true;
          this.subComplexes = data;
          this.selectedDevice = deviceId;
        });
    },
    goToSummary(deviceId, name) {
      this.$store.commit("setSelectedDeviceName", name);
      this.$router.push(`/device-summary/${deviceId}`);
    },
    getIsSubComplex() {
      request
        .get(`/publicData/is-subComplex/${this.complexId}`)
        .then(response => {
          var data = response.data.result;
          this.isSubComplex = data;
        });
    },
    addNewDevice() {
      this.$router.push({
        name: "CreateDevice",
        params: {
          id: this.complexId
        }
      });
    },
    addDeviceToComplex() {
      request
        .put(
          `/device/changeDeviceComplex/${this.selectedSubComplexId}/${this.selectedDevice}`
        )
        .then(() => {
          this.dialog = false;
        });
    },
    async getDevices() {
      const { sortDesc, sortBy, page, itemsPerPage } = this.options;
      this.loading = true;

      const filterQuery = Object.keys(this.options)
        .filter(x => this.options[x] !== null && this.options[x] !== undefined)
        .map(key => `${key}=${this.options[key]}`)
        .join("&");

      this.loading = true;
      await request
        .get(`/device/devices/${this.complexId}?` + filterQuery)
        .then(response => {
          var data = response.data.result;
          this.deviceList = data.result;
          this.totalDevices = data.totalItems;
          this.pages = data.pageCount;
        })
        .catch(error => {
          alert(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
